// eslint-disable-next-line import/no-unresolved
import { Component } from 'preact';
import PropTypes from 'prop-types';
import { isSafari } from '%/utils/isSafari';
import WhatsAppForm from './WhatsAppForm';

class WhatsAppFormApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmittingForm: false,
      errorSendingForm: false,
      showOverlay: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCloseOverlay = this.handleCloseOverlay.bind(this);
  }

  handleCloseOverlay() {
    this.setState({ showOverlay: false });
  }

  handleSubmit(e, params) {
    this.setState({ isSubmittingForm: true });

    return window.serviceConversion
      .convert(params)
      .then(() => {
        this.setState({
          isSubmittingForm: false,
          errorSendingForm: false,
        });
        this.openWhatsAppLink();
      })
      .catch(error => {
        this.setState({
          isSubmittingForm: false,
          errorSendingForm: true,
        });
        console.error(error);
      })
      .then(() => {
        this.setState({
          showOverlay: true,
        });
      });
  }

  openWhatsAppLink() {
    const { category } = this.props;
    const { errorSendingForm } = this.state;

    let link = this.props.link;

    const comboBox = document.querySelector(
      '.unit-select .choices__item.choices__item--selectable',
    );

    // se encontrar o combobox verifica a necessidade de alterar o link
    if (comboBox) {
      const selected_unit = comboBox.dataset.value;

      if (this.props.phones) {
        this.props.phones.forEach(current => {
          if (
            current.area.toLowerCase() === category.toLowerCase() &&
            current.unit === selected_unit
          ) {
            link = current.link;
          }
        });
      }
    }

    if (link && !errorSendingForm) {
      if (isSafari()) {
        window.location.href = link;
      } else {
        window.open(link, '_blank');
      }
    }
  }

  render() {
    const {
      formId,
      units,
      filterUnitsByLocation,
      unit,
      product,
      channel,
      category,
      whatsAppResponder,
    } = this.props;

    return (
      <WhatsAppForm
        showEmail={this.props.showEmail}
        showContactOptions={this.props.showContactOptions}
        formId={formId}
        handleSubmit={this.handleSubmit}
        isSubmittingForm={this.state.isSubmittingForm}
        errorSendingForm={this.state.errorSendingForm}
        handleCloseOverlay={this.handleCloseOverlay}
        showOverlay={this.state.showOverlay}
        filterUnitsByLocation={filterUnitsByLocation}
        linkPrivacyPolicy={this.props.linkPrivacyPolicy}
        units={units}
        unit={unit}
        product={product}
        channel={channel}
        category={category}
        brand={this.props.brand}
        country={this.props.country}
        bait={this.props.bait}
        whatsAppResponder={whatsAppResponder}
        showUnits={this.props.showUnits}
        showCpf={this.props.showCpf}
        showCustomerType={this.props.showCustomerType}
        cloneId={this.props.cloneId}
        versions={this.props.versions}
        customFields={this.props.customFields}
        showLocationFields={this.props.showLocationFields}
        contactsWithDynamicRequired={this.props.contactsWithDynamicRequired}
        shouldShowDataPermissions={this.props.shouldShowDataPermissions}
        dataPermissionsCustomText={this.props.dataPermissionsCustomText}
        modelCategory={this.props.modelCategory}
        sendModelAsProduct={this.props.sendModelAsProduct}
      />
    );
  }
}

WhatsAppFormApp.defaultProps = {
  units: [],
  brand: '-',
  showUnits: true,
  showCpf: false,
  versions: [],
  showEmail: true,
  showContactOptions: true,
  showLocationFields: false,
  contactsWithDynamicRequired: false,
  shouldShowDataPermissions: false,
  sendModelAsProduct: false,
  showCustomerType: false,
};

WhatsAppFormApp.propTypes = {
  formId: PropTypes.string,
  units: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  unit: PropTypes.string,
  filterUnitsByLocation: PropTypes.bool,
  product: PropTypes.string,
  channel: PropTypes.string,
  showEmail: PropTypes.bool,
  showContactOptions: PropTypes.bool,
  showCustomerType: PropTypes.bool,
  category: PropTypes.string,
  brand: PropTypes.string,
  country: PropTypes.string,
  bait: PropTypes.string,
  showUnits: PropTypes.bool,
  showCpf: PropTypes.bool,
  showLocationFields: PropTypes.bool,
  phones: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      unit: PropTypes.string,
      area: PropTypes.string,
    }),
  ),
  cloneId: PropTypes.string,
  versions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  customFields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  contactsWithDynamicRequired: PropTypes.bool,
  shouldShowDataPermissions: PropTypes.bool,
  dataPermissionsCustomText: PropTypes.string,
  sendModelAsProduct: PropTypes.bool,
  link: PropTypes.string,
  linkPrivacyPolicy: PropTypes.string,
  whatsAppResponder: PropTypes.bool,
  modelCategory: PropTypes.string,
};

export default WhatsAppFormApp;
